module.exports = __webpack_public_path__ + "static/media/plus-dis.58734cf1.svg";